import { Loading } from "../../elements/Loading";
import JourneyPlannerCanvas from "./JourneyPlannerCanvas";
import { useJourneyPlanner } from "./JourneyPlannerContext";

function JourneyPlannerCanvasPanel() {
  const { activeDrag, loading } = useJourneyPlanner();

  return loading ? <Loading /> : <JourneyPlannerCanvas activeDrag={activeDrag} />;
}

export default JourneyPlannerCanvasPanel;
